import EnumIdType from "../modules/patient/enums/EnumIdType";

const isPatientIdReadFromUAE = (patient) => {
    return patient?.patientIdReadFrom === "UAE";
}

const getPatientName = (firstName, middleName, lastName) => {
    return (firstName ? firstName : "") + (middleName ? " " + middleName : "") + (lastName ? " " + lastName : "")
}

const getPatientsName = (patient) => {
    if (!patient) {
        return ""
    }
    return getPatientName(patient.firstName, patient.middleName, patient.lastName);
}

const getPatientId = (patient) => {
    return isPatientIdReadFromUAE(patient) ?
        patient.eid?.replace(/(\d{3})(\d{4})(\d{7})(\d)/, '$1-$2-$3-$4') : patient.eid
}

const getPatientIdType = (patient) => {
    return patient.idType && patient.idType !== 'OTHER' ? EnumIdType[patient.idType].name : patient.otherIdType
}

export default {isPatientIdReadFromUAE, getPatientName, getPatientsName, getPatientId, getPatientIdType};
